module.exports = __webpack_public_path__ + "media/images/ecommerce/product_01-16599682db9298fa5466142980dedeeb.svg";